import { posDb, type CreditSnapshot } from '@/db/pos-database';
import { encryptForStorage, decryptFromStorage } from '@/db/encrypted-access';
import type { CustomerCreditAccount } from './credit-account.service';

/**
 * L02 (G-C1) — the till's copy of a customer's credit account, saved each time
 * it is read online, so the billing screen can show what they owe offline as
 * "Last known · <time>". Written with put() of an encrypted row, never update().
 */

export async function saveCreditSnapshot(
  account: CustomerCreditAccount,
  asOf: Date = new Date(),
): Promise<CreditSnapshot> {
  const row: CreditSnapshot = {
    customer_id: account.customer_id,
    account_id: account.id,
    credit_limit: Number(account.credit_limit),
    outstanding: Number(account.outstanding_balance),
    as_of: asOf.toISOString(),
  };
  await posDb.credit_snapshots.put(await encryptForStorage(row, 'credit_snapshots'));
  return row;
}

export async function getCreditSnapshot(customerId: string): Promise<CreditSnapshot | undefined> {
  return decryptFromStorage(await posDb.credit_snapshots.get(customerId));
}

export async function deleteCreditSnapshot(customerId: string): Promise<void> {
  await posDb.credit_snapshots.delete(customerId);
}
